import {
  Box,
  Button,
  Card,
  Grid2,
  Typography,
  Alert,
  AlertTitle,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { AppContext } from '../../../store/AppContext';
import { getFacilitiyV2, getReportsV2 } from '../../../helpers/api';
import LoaderSkeleton from '../../common/LoaderSkeleton';
import PersonnelStatCards from './personnel/PersonnelStatCards';
import PersonnelFacilityQuarter from './personnel/PersonnelFacilityQuarter';

// Icons for the new UI elements
import {
  Science,
  ArrowForward,
  AssignmentLate,
  CheckCircleOutline,
  History,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import ConsultantStatCards from './consultant/ConsultantStatCards';
import ConsultantFacilityQuarter from './consultant/ConsultantFacilityQuarter';
import ConsultantAlert from './consultant/ConsultantAlert';
import ConsultantActivity from './consultant/ConsultantActivity';

const ConsultantDashboardScreen = withRouter(({ props }) => {
  const { state } = useContext(AppContext);
  const { firstname, lastname, status } = state?.auth?.result?.data || {};

  const [facilityList, setFacilityList] = useState([]);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [facilityInitSelected, setFacilityInitSelected] = useState();

  const [resultList, setResultList] = useState([]);
  const [resultLoading, setResultLoading] = useState(false);

  // console.log('resultList', resultList);

  useEffect(() => {
    fetchFacilityList();
    fetchResultList();
  }, []);

  const fetchFacilityList = async () => {
    setFacilityLoading(true);
    try {
      const res = await getFacilitiyV2('', '', '', '', '', '', '', '', 1, 1000);
      const { data, status } = res?.result || {};
      if (status?.code === '00') {
        setFacilityList(data);
        setFacilityInitSelected(data[0]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setFacilityLoading(false);
    }
  };

  const fetchResultList = async () => {
    setResultLoading(true);
    try {
      const res = await getReportsV2('', '', '', '', '', '', 1, 100);
      const { data, status } = res?.result;
      if (status?.code === '00') setResultList(data);
    } catch (error) {
      console.log(error);
    } finally {
      setResultLoading(false);
    }
  };

  return (
    // 1. FIXED BACKGROUND: minHeight '100vh' ensures the background never cuts off
    <Box sx={{ minHeight: '100vh', bgcolor: '#F4F6F8', p: { xs: 2, md: 4 }, mt: -1 }}>
      <Grid2 container spacing={3}>
        {/* Header Section */}
        <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
          <Typography variant="h4" color="text.primary" fontWeight={700} gutterBottom>
            Welcome back, {firstname} 👋
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Here is what is happening across your facilities today.
          </Typography>
        </Grid2>

        <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
          <ConsultantAlert resultList={resultList} resultLoading={resultLoading} />
        </Grid2>

        {/* Top Stat Cards */}
        <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
          <ConsultantStatCards
            facilityList={facilityList}
            facilityLoading={facilityLoading}
            resultList={resultList}
            resultLoading={resultLoading}
          />
        </Grid2>

        {/* Left Column: Monitoring Schedule */}
        <Grid2 size={{ lg: 7, md: 12, sm: 12, xs: 12 }}>
          {facilityLoading ? (
            <Box mt={2}>
              <LoaderSkeleton />
              <LoaderSkeleton />
            </Box>
          ) : facilityList?.length < 1 ? (
            <Card
              elevation={0}
              sx={{
                p: 4,
                borderRadius: '16px',
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="h6" color="textSecondary">
                It appears you belong to no facility. Please contact an admin.
              </Typography>
            </Card>
          ) : (
            <ConsultantFacilityQuarter
              facilityList={facilityList}
              facilityLoading={facilityLoading}
              initFacility={facilityInitSelected}
            />
          )}
        </Grid2>

        {/* Right Column: 3. NEW PENDING TASKS & ACTIVITY */}
        <Grid2 size={{ lg: 5, md: 12, sm: 12, xs: 12 }}>
          <ConsultantActivity resultList={resultList} resultLoading={resultLoading} />
        </Grid2>
      </Grid2>
    </Box>
  );
});

export default ConsultantDashboardScreen;
